import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { TEXT_NORMAL, TEXT_SMALL } from "../../style";
import "./selfTestShow.css";

const OPTION_LABELS = ["A", "B", "C", "D"];

const soundSrc = (name) => `${process.env.PUBLIC_URL}/sounds/${name}.mp3`;

let activeSound = null;

function playSelfTestSound(name) {
    activeSound?.pause();
    activeSound = new Audio(soundSrc(name));
    activeSound.volume = 0.9;
    activeSound.play().catch(() => {});
}

export default function Question({
    setTest,
    currentQuestion,
    question,
    choice_one,
    choice_two,
    choice_three,
    choice_four,
    correct_choice,
    loadNextQuestion,
}) {
    const [selectedChoice, setSelectedChoice] = useState(null);
    const [isAnswering, setIsAnswering] = useState(false);

    useEffect(() => {
        setSelectedChoice(null);
        setIsAnswering(false);
        playSelfTestSound("question-reveal");

        return () => {
            activeSound?.pause();
        };
    }, [currentQuestion]);

    const choices = [choice_one, choice_two, choice_three, choice_four];

    const handleChoiceSelection = (value) => {
        if (isAnswering) return;

        setSelectedChoice(value);
        setIsAnswering(true);
        playSelfTestSound(value === correct_choice ? "correct-answer" : "wrong-answer");

        if (value === correct_choice) {
            setTest((prev) => ({
                ...prev,
                correctAnswers: (prev.correctAnswers || 0) + 1,
                questionsAttended: (prev.questionsAttended || 0) + 1,
                score: (prev.score || 0) + 1,
            }));
        } else {
            setTest((prev) => ({
                ...prev,
                questionsAttended: (prev.questionsAttended || 0) + 1,
                incorrectAnswers: (prev.incorrectAnswers || 0) + 1,
                score: (prev.score || 0) + 1,
            }));
        }
    };

    const getChoiceClass = (choice) => {
        const base = "self-test-option flex align-items-center gap-2 border-round-3xl border-2 p-3 cursor-pointer";

        if (!selectedChoice) {
            return base;
        }

        if (choice === correct_choice) {
            return `${base} is-correct`;
        }

        if (choice === selectedChoice) {
            return `${base} is-wrong`;
        }

        return `${base} opacity-40 cursor-default`;
    };

    return (
        <div className="self-test-question relative flex flex-column px-2" key={currentQuestion}>
            <div className="self-test-panel relative z-1 border-3 border-round-3xl px-3 py-4 text-center">
                <span className={`${TEXT_SMALL} text-yellow-300 font-bold block mb-2`}>Question {currentQuestion + 1}</span>
                <span className={`${TEXT_NORMAL} text-white font-semibold line-height-3 word-break-all`}>{question}</span>
            </div>

            <div className={`self-test-options relative z-1 grid mt-3 ${selectedChoice ? "" : "is-open"}`}>
                {choices.map((choice, index) => (
                    <div key={`${currentQuestion}-${OPTION_LABELS[index]}-${choice}`} className="col-12 md:col-6">
                        <div
                            role="button"
                            tabIndex={isAnswering ? -1 : 0}
                            className={getChoiceClass(choice)}
                            onClick={() => handleChoiceSelection(choice)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleChoiceSelection(choice);
                                }
                            }}
                        >
                            <span
                                className={`${TEXT_SMALL} w-2rem h-2rem flex align-items-center justify-content-center border-circle bg-yellow-400 text-bluegray-900 font-bold flex-shrink-0`}
                            >
                                {OPTION_LABELS[index]}
                            </span>
                            <span className={`${TEXT_SMALL} font-medium`}>{choice}</span>
                        </div>
                    </div>
                ))}
            </div>

            <Button
                disabled={!selectedChoice}
                onClick={loadNextQuestion}
                className="relative z-1 w-full mt-2"
                iconPos="right"
                icon="pi pi-arrow-right"
                severity="warning"
                label="Next"
                size="small"
            />
        </div>
    );
}
